import { classEnum } from "./base";

export const InvoiceTypeEnum = new (class extends classEnum([
    {
        label: "Umum",
        value: "G",
    },
    {
        label: "Pelanggan",
        value: "C",
    },
    {
        label: "Reseller",
        value: "R",
    },
]) {
    public get valuesReport() {
        return this.values.filter((v) => v !== "G");
    }

    public get selectReport() {
        return this.select.filter((v) => v.value !== "G");
    }

    public get ValuesReport(): this["valuesReport"][number] {
        throw new Error("ValuesReport can't be used as a value");
    }
})();

export namespace InvoiceTypeEnum {
    export type Labels = (typeof InvoiceTypeEnum)["labels"][number];
    export type Values = (typeof InvoiceTypeEnum)["values"][number];
    export type ValuesReport = (typeof InvoiceTypeEnum)["valuesReport"][number];
}
